import { DEFAULT_PERIOD, cloneDefaultParameters } from "../constants/defaults";

const now = "2026-02-24T10:00:00.000Z";

const mockScenarios = [
  {
    id: "scn-base",
    name: "Base Operacional",
    kind: "official",
    period: DEFAULT_PERIOD,
    parameters: {
      ...cloneDefaultParameters(),
    },
    notes: "Cenário de referência para comparação.",
    createdAt: now,
    updatedAt: now,
    isDirty: true,
    lastRun: null,
  },
  {
    id: "scn-turno-extra",
    name: "Rascunho - Turno Extra",
    kind: "draft",
    period: DEFAULT_PERIOD,
    parameters: {
      ...cloneDefaultParameters(),
      operatorCount: 26,
      maintenanceHours: 14,
      lossesPercent: 5,
      productivityAvg: 11.1,
    },
    notes: "Hipótese com reforço de equipe.",
    createdAt: "2026-02-24T10:10:00.000Z",
    updatedAt: "2026-02-24T10:10:00.000Z",
    isDirty: true,
    lastRun: null,
  },
  {
    id: "scn-risco-alto",
    name: "Rascunho - Conservador",
    kind: "draft",
    period: "2026-W10",
    parameters: {
      ...cloneDefaultParameters(),
      maintenanceHours: 24,
      lossesPercent: 8,
      riskFactor: 14,
      tolerancePercent: 4,
    },
    notes: "Simulação conservadora para semana de manutenção.",
    createdAt: "2026-02-24T10:15:00.000Z",
    updatedAt: "2026-02-24T10:15:00.000Z",
    isDirty: true,
    lastRun: null,
  },
];

export default mockScenarios;
